<template>
 <div>
  <map-info-modal ref="mapInfoModalRef">
   <label slot="title">自定义信息点</label>
   <div slot="content">
    <div>
     <label>地址：</label><label>{{content.addr}}</label>
    </div>
    <div style="margin-top: 3px;">
     <label>经度：{{content.longitude}}</label><label style="margin-left: 10px;">纬度：{{content.latitude}}</label>
    </div>
    <div style="margin-top: 3px;">
     <label>名称：</label><label>{{content.name}}</label>
    </div>
    <div style="margin-top: 3px;">
     <label>备注：</label><label>{{content.remark}}</label>
    </div>
    <div style="margin-top: 3px; text-align: right; margin-right: 10px;">
     <Button size="small" @click="onModify">修改</Button>
     <Button size="small" @click="onDelete">删除</Button>
    </div>
   </div>
  </map-info-modal>
 </div>
</template>
<script>

import MapInfoModal from '@/view/ddm/components/map-info-windows/map-info-modal'

import store from '@/store'

export default {
  name: 'customerpointdetailmodal',
  components: {
    MapInfoModal
  },
  props: {},
  data () {
    return {
      mapInfoModalRef: null,
      modifyCustomerPointModalRef: null,
      content: {
        id: null,
        addr: null,
        longitude: null,
        latitude: null,
        name: null,
        remark: null
      }
    }
  },
  methods: {
    onModify () {
      this.$emit('on-edit', this.content.id)
    },
    onDelete () {
      if (!this.content.id) {
        this.$Message.error('无效id')
      }
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认删除自定义点</p>',
        onOk: () => {
          store.dispatch('CustomPOIServ_DeleteObj', {
            params: { id: this.content.id },
            urlparams: null
          }).then(() => {
            this.$Message.success('删除成功')
            this.$emit('on-deleted', this.content.id)
            this.onClose()
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {
        }
      })
    },
    loadData (id) {
      store.dispatch('CustomPOIServ_GetDetail', {
        params: { id: id },
        urlparams: null
      }).then(() => {
        this.content = store.getters.get_CustomPOI_GetDetailResult
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onMapPan (delta) {
      this.mapInfoModalRef.onMapPan(delta)
    },
    onMapPanEnd (delta) {
      this.mapInfoModalRef.onMapPanEnd(delta)
    },
    onMapZoom () {
      this.mapInfoModalRef.onMapZoom()
    },
    onMapZoomEnd () {
      this.mapInfoModalRef.onMapZoomEnd()
    },
    onClose () {
      this.mapInfoModalRef.onClose()
    },
    moveModalByDelta (deltaScreenX, deltaScreenY) {
      this.mapInfoModalRef.moveModalByDelta(deltaScreenX, deltaScreenY)
    },
    moveModal (screenX, screenY) {
      this.mapInfoModalRef.moveModal(screenX, screenY)
    },
    moveModalByWebPoint (webPoint) {
      this.mapInfoModalRef.moveModalByWebPoint(webPoint)
    },
    showModalByLatLng (customPOIId, map, arcgisModules, wgs84Lng, wgs84Lat) {
      this.mapInfoModalRef.showModalByLatLng(map, arcgisModules, wgs84Lng, wgs84Lat)
      this.loadData(customPOIId)
    },
    showModal (customPOIId, map, arcgisModules, webX, webY) {
      this.mapInfoModalRef.showModal(map, arcgisModules, webX, webY)
      this.loadData(customPOIId)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.mapInfoModalRef = this.$refs.mapInfoModalRef
      this.modifyCustomerPointModalRef = this.$refs.modifyCustomerPointModalRef
      this.mapInfoModalRef.styleData.height = 200
      this.mapInfoModalRef.styleData.width = 200
    })
  }
}
</script>
